import { apiStoreSetup } from "../../api/storeSetup";
import { bookingProcessSetPeople } from "./bookingProcess";

export const STORE_SELECT = 'STORE_SELECT';
export const storeSelect = storeId => ({ type: STORE_SELECT, storeId });

export const STORE_GET_SETUP_REQUEST_START = 'STORE_GET_SETUP_REQUEST_START';
export const storeGetSetupRequestStart = storeId => ({ type: STORE_GET_SETUP_REQUEST_START, storeId });

export const STORE_GET_SETUP_REQUEST_ERROR = 'STORE_GET_SETUP_REQUEST_ERROR';
const storeGetSetupRequestError = storeId => ({ type: STORE_GET_SETUP_REQUEST_ERROR, storeId });

export const STORE_SET_IS_OPENED = 'STORE_SET_IS_OPENED';
const storeSetIsOpened = (storeId, isOpened) => ({ type: STORE_SET_IS_OPENED, storeId, isOpened });

export const STORE_GET_SETUP_REQUEST_SUCCESS = 'STORE_GET_SETUP_REQUEST_SUCCESS';
const storeGetSetupRequestSuccess = ({
    storeId,
    storeName,
    maxOnlinePartySize,
    termsAndConditions,
    services,
    lunchTimes,
    dinnerTimes,
    maxBookingDaysInAdvance,
    termsAndConditionsTranslation,
    onlinePartySizeDefault,
    minOnlinePartySize,
    logo,
    popupDetails,
    showPopup,
    availabilityTranslations,
    phone,
}) =>
    ({
        type: STORE_GET_SETUP_REQUEST_SUCCESS,
        storeId,
        storeName,
        maxOnlinePartySize,
        termsAndConditions,
        services,
        lunchTimes,
        dinnerTimes,
        maxBookingDaysInAdvance,
        termsAndConditionsTranslation,
        onlinePartySizeDefault,
        minOnlinePartySize,
        logo,
        popupDetails,
        showPopup,
        availabilityTranslations,
        phone,
    });

export const storeGetSetup = storeId => async (dispatch, getState) => {
    const { storeReducer, storesReducer, settingsReducer } = getState();
    let storeDetails = null;
    try {
        storeDetails = storesReducer.stores[storesReducer.selectedCountry.id].find(store => store.id === storeId);
    } catch (error) {
        // It means edit booking
    }

    // Check if the store is closed
    if (storeDetails && !storeDetails.isOpened) {
        return dispatch(storeSetIsOpened(storeId, false));
    }

    // Check if we already fetch the store details
    const potentialStore = storeReducer.stores[storeReducer.storeIdSelected];
    if (!(!potentialStore || potentialStore.hasError)) {
        if (potentialStore) {
            dispatch(bookingProcessSetPeople(potentialStore.onlinePartySizeDefault));
        }
        return;
    }
    if (potentialStore && potentialStore.isFetching) return;

    dispatch(storeGetSetupRequestStart(storeId));

    let store = null;
    try {
        store = await apiStoreSetup(storeId, settingsReducer.language);
    } catch (error) {
        dispatch(storeGetSetupRequestError(storeId));
        return false;
    }

    let lunchTimes = store.Services.find(s => s.Name === 'Lunch' || s.Name === 'Pranzo');
    let dinnerTimes = store.Services.find(s => s.Name === 'Dinner' || s.Name === 'Cena');
    if (lunchTimes) {
        lunchTimes = { timeFrom: lunchTimes.TimeFrom, timeLast: lunchTimes.LastBookingTime }
    }
    if (dinnerTimes) {
        dinnerTimes = { timeFrom: dinnerTimes.TimeFrom, timeLast: dinnerTimes.LastBookingTime }
    }

    let termsAndConditionsTranslation = '';

    if (storeDetails && storeDetails.translations[settingsReducer.language]) {
        termsAndConditionsTranslation = storeDetails.translations[settingsReducer.language];
    } else {
        termsAndConditionsTranslation = store.TermsAndConditions;
    }

    let popupDetails = null;
    let showPopup = false;
    if (storeDetails) {
        try {
            popupDetails = {
                primaryTitle: storeDetails.popupTranslations.primaryTitle[settingsReducer.language],
                primaryMessage: storeDetails.popupTranslations.primaryMessage[settingsReducer.language],
                primaryButton: storeDetails.popupTranslations.primaryButton[settingsReducer.language],
                secondaryTitle: storeDetails.popupTranslations.secondaryTitle[settingsReducer.language],
                secondaryMessage: storeDetails.popupTranslations.secondaryMessage[settingsReducer.language],
                secondaryButton: storeDetails && storeDetails.phone ? storeDetails.phone : '',
            }
            showPopup =
              popupDetails.primaryTitle !== ""
                && popupDetails.primaryMessage !== ""
                && popupDetails.primaryButton !== "";
        } catch (error) {
            console.log(error);
            popupDetails = null;
        }
    }

    let availabilityTranslations = null;
    if (storeDetails && storeDetails.availabilityTranslations) {
        try {
            let primaryTitle = '';
            let primaryMessageAvailable = '';
            let primaryMessageNotAvailable = '';
            let primaryButton = '';

            if (storeDetails.availabilityTranslations.primaryTitle) {
                primaryTitle = storeDetails.availabilityTranslations.primaryTitle[settingsReducer.language];
            }

            if (storeDetails.availabilityTranslations.primaryMessage) {
                const pm = storeDetails.availabilityTranslations.primaryMessage[settingsReducer.language];
                if (pm.with_time) {
                    primaryMessageAvailable = pm.with_time;
                }
                if (pm.no_time) {
                    primaryMessageNotAvailable = pm.no_time;
                }
            }

            if (storeDetails.availabilityTranslations.primaryButton) {
                primaryButton = storeDetails.availabilityTranslations.primaryButton[settingsReducer.language];
            }

            availabilityTranslations = {
                primaryTitle,
                primaryMessageAvailable,
                primaryMessageNotAvailable,
                primaryButton,
            }
        } catch (error) {
            console.log(error);
            availabilityTranslations = null;
        }
    }

    let logo = null;
    if (storeDetails && storeDetails.logo && storeDetails.logo.url) {
        logo = storeDetails.logo.url;
    }

    dispatch(bookingProcessSetPeople(store.OnlinePartySizeDefault));
    return dispatch(storeGetSetupRequestSuccess({
        storeId,
        storeName: store.Name,
        maxOnlinePartySize: store.MaxOnlinePartySize,
        onlinePartySizeDefault: store.OnlinePartySizeDefault,
        minOnlinePartySize: store.MinOnlinePartySize,
        maxBookingDaysInAdvance: store.AcceptBookingsDaysInAdvance,
        termsAndConditions: store.TermsAndConditions,
        services: store.Services,
        lunchTimes,
        dinnerTimes,
        termsAndConditionsTranslation,
        logo,
        popupDetails,
        showPopup,
        availabilityTranslations,
        phone: storeDetails && storeDetails.phone ? storeDetails.phone : '',
    }));
}


// WEBPACK FOOTER //
// ./src/store/actions/store.js